export const getPathNameWithoutQueryParams = (pathname: string) => {
  const url = new URL(pathname, window.location.origin);
  return url.pathname;
};
